import { Component, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TitleCasePipe } from '@angular/common';

import { SearchBase } from '../search-base';
import { SearchService } from '../search.service';
import { SharedFilterComponent } from './../../shared/shared-filter/shared-filter.component';
import { GoogleAnalyticsEventsService } from './../../services/google-analytics-events.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-decisions',
  templateUrl: './decisions.component.html',
  styleUrls: ['./decisions.component.scss', '../search.component.scss'],
  providers: [TitleCasePipe]
})
export class DecisionsComponent extends SearchBase implements OnInit, OnDestroy {
  domain = 'decisions';
  title = 'Board Decisions';

  @ViewChild(SharedFilterComponent)
  sharedFilterComponent: SharedFilterComponent;

  private showFullText:boolean = false;

  constructor(
    protected searchService: SearchService,
    protected formBuilder: FormBuilder,
    protected titlecasePipe: TitleCasePipe,
    protected googleAnalyticsService: GoogleAnalyticsEventsService,
    protected utilService:UtilService,
    protected route: ActivatedRoute
  ) {
    super(searchService, formBuilder, titlecasePipe, googleAnalyticsService, route);
  }

  ngOnInit() {

    // set the default sorting:
    if (!this.sortMap) {
      this.sortMap = [{ sortColumnName: 'issueDate', order: 'desc' }];
    }

    this.utilService.showFullText$.subscribe(flag => {
      this.toggleDisclaimer();
    });

    this.searchService.showFullText$.subscribe(flag => {
      this.showFullText = flag;
    });

    this.init();

  }

  @HostListener('window:beforeunload')
  ngOnDestroy() {
    this.destroy();
  }

  removeSearchText(tag: any) {
    this.searchTextForm.controls["searchText"].setValue("");
    this.searchByDocumentText(this.searchTextForm);
  }

  searchByDocumentText(form: FormGroup) {
    this.searchText = form.get('searchText').value;
    this.clearFilters();
    this.search([], []);
    this.googleAnalyticsService.emitEvent('Decision Search', 'Button Click', 'Search');
  }

  expandText() {
    this.showFullText = !this.showFullText;
    this.searchService.publishShowFullText(this.showFullText);
  }

  isPanelCollapsed(facetMap: any, tagKey: string) {
    if(facetMap.some(facet => facet[tagKey])) {
      return false;
    } else {
      return true;
    }
  }
}

